<div class="container-fluid px-0">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img class="group" [src]="'assets/images/phone.png'" [srcset]="'assets/images/phone@2x.png 2x, assets/images/phone@3x.png 3x'" alt="logo"/>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label class="phone-notification-title">Telefonunuza Bildirim Gönderdik!</label>
    </div>
    <div class="col-12 d-flex justify-content-center">
      <label class="paycell-information">Paycell uygulamanıza gelen bildirim ile ödeme<br> işleminize telefonunuzdan
        devam edebilirsiniz.</label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="path"></div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label class="not-information">Bildirim gelmedi mi? <span class="text-style">Webden devam et.</span></label>
    </div>
  </div>
</div>
